import React from 'react'
import cn from 'classnames'
import styles from 'components/panels/panel-toggle-button.module.scss'
import PanelToggleOnePanelIcon from 'components/shared/icons/PanelToggleOnePanelIcon'
import PanelToggleThreePanelIcon from 'components/shared/icons/PanelToggleThreePanelIcon'
import WithTooltip from 'components/shared/WithTooltip'
import { isMobile } from 'lib/device'
import { setUserProps, logEv } from 'lib/log'

export default function PanelToggleButton({ onePanel, toggleOnePanel, contextStyles }) {
    // Only show on desktop
    if (isMobile) return null

    const onClick = () => {
        try {
            const nextNumPanels = onePanel ? 3 : 1
            setUserProps({ num_panels: nextNumPanels })
            logEv('TOGGLE_PANEL_MODE', { num_panels: nextNumPanels })
        } catch (_) {}
        toggleOnePanel()
    }

    return (
        <WithTooltip tip={onePanel ? 'Show three panels' : 'Show one panel'} place="bottom">
            <div className={cn(styles.panelToggleButton, contextStyles)} onClick={onClick}>
                {onePanel ? <PanelToggleThreePanelIcon /> : <PanelToggleOnePanelIcon />}
            </div>
        </WithTooltip>
    )
}
